
    var riot = require('riot')
    //src: starling/src/tags/node-alignment-panel.html
riot.tag2('node-alignment-panel',
  '<ul ref="menuList" class="floating-menu_list floating-menu_list--grid" riot-style="{getStyle()}"> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{alignTop}" data-tip="Top" data-tip-align="true-left" data-track="{getTrackingLabel()}" data-track-action="Align-Top" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-top-icon"></use> </svg> </li> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{alignLeft}" data-tip="Left" data-tip-align="true-right" data-track="{getTrackingLabel()}" data-track-action="Align-Left" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-left-icon"></use> </svg> </li> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{alignCenter}" data-tip="Middle" data-tip-align="true-left" data-track="{getTrackingLabel()}" data-track-action="Align-Middle" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-middle-icon"></use> </svg> </li> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{alignMiddle}" data-tip="Center" data-tip-align="true-right" data-track="{getTrackingLabel()}" data-track-action="Align-Center" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-center-icon"></use> </svg> </li> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{alignBottom}" data-tip="Bottom" data-tip-align="true-left" data-track="{getTrackingLabel()}" data-track-action="Align-Bottom" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-bottom-icon"></use> </svg> </li> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{alignRight}" data-tip="Right" data-tip-align="true-right" data-track="{getTrackingLabel()}" data-track-action="Align-Right" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-right-icon"></use> </svg> </li> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{snapGrid}" data-tip="Snap" data-tip-align="true-left" data-track="{getTrackingLabel()}" data-track-action="Align-Snap" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-snap-icon"></use> </svg> </li> <li class="floating-menu_item {floating-menu_item--disabled: !hasAlignableNodes()}" onclick="{alignCircle}" data-tip="Circle" data-tip-align="true-right" data-track="{getTrackingLabel()}" data-track-action="Align-Circle" data-track-label="Align"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#align-circle-icon"></use> </svg> </li> </ul>',
  '',
  'class="floating-menu floating-menu--fixed floating-menu--hidden" onmouseenter="{handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _util = require('lib/util');

var _geom = require('lib/geom');

var _store = require('../store');

var _smallestCircle = require('lib/smallest-circle');

var _smallestCircle2 = _interopRequireDefault(_smallestCircle);

var _nodesUi = require('lib/nodes-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PANEL_WIDTH = 72;

this.canvas = opts.canvas;
this.operation = opts.operation;
this.canvas.nodeAlignmentPanelTag = this;
this.isOpen = false;
this.origin = null;

this.summon = function (_ref) {
  var referenceEl = _ref.referenceEl,
      positionToLeft = _ref.positionToLeft,
      origin = _ref.origin;

  var rect = referenceEl.getBoundingClientRect();

  _this.positionToLeft = positionToLeft;
  _this.style = 'top: ' + _this.y + 'px; left: ' + _this.x + 'px;';
  _this.isOpen = true;
  _this.origin = origin;

  if (_this.fromOrigin('toolbar')) {
    _this.y = rect.bottom;
    _this.x = rect.left + rect.width / 2 - PANEL_WIDTH / 2;
    _this.style = 'top: ' + (_this.y + 4) + 'px; left: ' + _this.x + 'px;';
  } else {
    _this.y = rect.top;
    _this.x = rect.right;
    //account for margin...
    _this.style = 'top: ' + (_this.y - 10) + 'px; left: ' + _this.x + 'px;';
    if (_this.positionToLeft) {
      _this.style = 'top: ' + (_this.y + 10) + 'px; right: ' + (window.innerWidth - rect.left) + 'px;';
    }
  }

  _this.prevNodePositions = [];
  _this.prevLinkAngles = [];

  _this.root.classList.remove('floating-menu--hidden');
  _this.update();
};

this.hide = function () {
  _this.isOpen = false;
  _this.origin = null;
  _this.root.classList.add('floating-menu--hidden');
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.getStyle = function () {
  return _this.style;
};

this.getAffectedLinkNodes = function () {
  var nodes = _this._getNodeList();
  return nodes.filter(function (n) {
    return Boolean(n.link());
  });
};

this.getSpacer = function () {
  return 40;

  var linkNodes = _this.getAffectedLinkNodes();
  if (!linkNodes || !linkNodes.length) {
    return 40; // default spacing
  }
  var maxHeight = Math.round(Math.max.apply(null, linkNodes.map(function (n) {
    return n.height;
  })));
  var maxWidth = Math.round(Math.max.apply(null, linkNodes.map(function (n) {
    return n.width;
  })));

  return Math.max(maxHeight, maxWidth) + 80;
};

this.getAlignableNodes = function () {
  var nodes = _this._getNodeList();
  if (!nodes) {
    return;
  }
  return nodes.filter(function (n) {
    return !n.link();
  });
};

// if more than 1 node is alignable, return true
this.hasAlignableNodes = function () {
  var nodes = _this.getAlignableNodes();
  if (nodes && nodes.length > 1) {
    return true;
  }
  return false;
};

this._getNodeList = function () {
  var nodes = _this.canvas.getSelectedNodes();
  if (!nodes || !nodes.length) {
    return;
  }

  var classification = _this.canvas.classifySelection(nodes);
  if (classification == 'top-level') {
    return nodes;
  }
  if (classification == 'shared-parent') {
    if (nodes[0].getGoverningLayoutName() == 'layout-freehand') {
      return nodes;
    }
  }
  // return only top level nodes
  var filtered = nodes.filter(function (n) {
    return !n.parentId;
  });
  if (!filtered.length) {
    return;
  }
  return filtered;
};

this.alignTop = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes) {
    return;
  }
  _this.capturePreviousPositions();
  var deltasX = _this.spaceNodes({ nodes: nodes, axis: 'x' });

  var avgYTop = (0, _geom.averageMap)(nodes, function (n) {
    return n.y;
  });

  for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var node = _ref2;

    node.applyMove({
      dx: deltasX ? deltasX[node.id].x : 0,
      dy: avgYTop - node.y,
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }
  _this.updateElements();
  _this.saveAlignment();
};

this.alignBottom = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes) {
    return;
  }
  _this.capturePreviousPositions();
  var deltasX = _this.spaceNodes({ nodes: nodes, axis: 'x' });

  var avgYBottom = (0, _geom.averageMap)(nodes, function (n) {
    return n.y + n.height;
  });

  for (var _iterator2 = nodes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref3 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref3 = _i2.value;
    }

    var node = _ref3;

    node.applyMove({
      dx: deltasX ? deltasX[node.id].x : 0,
      dy: avgYBottom - (node.y + node.height),
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }
  _this.updateElements();
  _this.saveAlignment();
};

this.alignCenter = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes) {
    return;
  }
  _this.capturePreviousPositions();
  var deltasX = _this.spaceNodes({ nodes: nodes, axis: 'x' });
  var avgY = (0, _geom.averageMap)(nodes, function (n) {
    return n.y + n.height / 2;
  });
  var deltasY = {};
  var deltas = [];
  for (var _iterator3 = nodes, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref4 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref4 = _i3.value;
    }

    var node = _ref4;

    deltasY[node.id] = avgY - node.y - node.height / 2;
    deltas.push(deltasY[node.id]);
  }

  if (deltas.every(function (v) {
    return v === deltas[0];
  })) {
    // no changes
    return;
  }
  for (var _iterator4 = nodes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
    var _ref5;

    if (_isArray4) {
      if (_i4 >= _iterator4.length) break;
      _ref5 = _iterator4[_i4++];
    } else {
      _i4 = _iterator4.next();
      if (_i4.done) break;
      _ref5 = _i4.value;
    }

    var _node = _ref5;

    _node.applyMove({
      dx: deltasX ? deltasX[_node.id].x : 0,
      dy: deltasY[_node.id] || 0,
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }
  _this.updateElements();
  _this.saveAlignment();
};

this.alignLeft = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes) {
    return;
  }
  _this.capturePreviousPositions();
  var deltasY = _this.spaceNodes({ nodes: nodes, axis: 'y' });

  var avgXLeft = (0, _geom.averageMap)(nodes, function (n) {
    return n.x;
  });

  for (var _iterator5 = nodes, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
    var _ref6;

    if (_isArray5) {
      if (_i5 >= _iterator5.length) break;
      _ref6 = _iterator5[_i5++];
    } else {
      _i5 = _iterator5.next();
      if (_i5.done) break;
      _ref6 = _i5.value;
    }

    var node = _ref6;

    node.applyMove({
      dx: avgXLeft - node.x,
      dy: deltasY ? deltasY[node.id].y : 0,
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }
  _this.updateElements();
  _this.saveAlignment();
};

this.alignRight = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes) {
    return;
  }
  _this.capturePreviousPositions();
  var deltasY = _this.spaceNodes({ nodes: nodes, axis: 'y' });

  var avgXRight = (0, _geom.averageMap)(nodes, function (n) {
    return n.x + n.width;
  });

  for (var _iterator6 = nodes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
    var _ref7;

    if (_isArray6) {
      if (_i6 >= _iterator6.length) break;
      _ref7 = _iterator6[_i6++];
    } else {
      _i6 = _iterator6.next();
      if (_i6.done) break;
      _ref7 = _i6.value;
    }

    var node = _ref7;

    node.applyMove({
      dx: avgXRight - (node.x + node.width),
      dy: deltasY ? deltasY[node.id].y : 0,
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }
  _this.updateElements();
  _this.saveAlignment();
};

this.alignMiddle = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes) {
    return;
  }
  _this.capturePreviousPositions();
  var deltasY = _this.spaceNodes({ nodes: nodes, axis: 'y' });
  var avgX = (0, _geom.averageMap)(nodes, function (n) {
    return n.x + n.width / 2;
  });

  var deltasX = {};
  var deltas = [];
  for (var _iterator7 = nodes, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
    var _ref8;

    if (_isArray7) {
      if (_i7 >= _iterator7.length) break;
      _ref8 = _iterator7[_i7++];
    } else {
      _i7 = _iterator7.next();
      if (_i7.done) break;
      _ref8 = _i7.value;
    }

    var node = _ref8;

    deltasX[node.id] = avgX - node.x - node.width / 2;
    deltas.push(deltasX[node.id]);
  }
  if (deltas.every(function (v) {
    return v === deltas[0];
  })) {
    // no changes
    return;
  }

  for (var _iterator8 = nodes, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
    var _ref9;

    if (_isArray8) {
      if (_i8 >= _iterator8.length) break;
      _ref9 = _iterator8[_i8++];
    } else {
      _i8 = _iterator8.next();
      if (_i8.done) break;
      _ref9 = _i8.value;
    }

    var _node2 = _ref9;

    _node2.applyMove({
      dx: deltasX[_node2.id] || 0,
      dy: deltasY ? deltasY[_node2.id].y : 0,
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }
  _this.updateElements();
  _this.saveAlignment();
};

// space nodes out along the given axis so they don't overlap
this.spaceNodes = function (_ref10) {
  var nodes = _ref10.nodes,
      axis = _ref10.axis;

  var sizeField = axis == 'x' ? 'width' : 'height';
  var avgAxis = (0, _geom.averageMap)(nodes, function (n) {
    return Math.round(n[axis]) + Math.round(n[sizeField]) / 2;
  });
  var sizeSum = nodes.map(function (n) {
    return Math.round(n[sizeField]);
  }).reduce(function (a, b) {
    return a + b;
  }, 0);
  var spacer = 10;
  var sizeTotal = sizeSum + spacer * (nodes.length - 1);
  var sortedNodes = nodes.sort(function (a, b) {
    return a[axis] - b[axis];
  });

  var newDeltas = {};
  var deltas = [];
  var positionList = [];
  for (var _iterator9 = sortedNodes, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
    var _ref11;

    if (_isArray9) {
      if (_i9 >= _iterator9.length) break;
      _ref11 = _iterator9[_i9++];
    } else {
      _i9 = _iterator9.next();
      if (_i9.done) break;
      _ref11 = _i9.value;
    }

    var node = _ref11;

    newDeltas[node.id] = {};
    var pos = node[axis];
    var newPosition = pos;
    if (!positionList.length) {
      // don't shift 1st item.
      newDeltas[node.id][axis] = 0;
    } else {
      // check for collisions
      newPosition = _this.getSafePosition({
        node: node,
        axis: axis,
        sizeField: sizeField,
        positionList: positionList,
        spacer: spacer
      });

      if (newPosition === pos) {
        // if no collision, no change,
        newDeltas[node.id][axis] = 0;
      } else {
        // if collision, set position based on previous item + spacing
        newDeltas[node.id][axis] = newPosition - pos;
      }
    }

    var newPos = {};
    newPos[axis] = newPosition;
    newPos[sizeField] = node[sizeField];
    newPos.title = node.title;
    positionList.push(newPos);

    deltas.push(newDeltas[node.id][axis]);
  }

  // figure out how much we need to shift the whole arrangement to keep its center the same as the original center of the selection
  var avgSize = (0, _geom.averageMap)(nodes, function (n) {
    return Math.round(n[sizeField]);
  });

  positionList.sort(function (a, b) {
    return a[axis] - b[axis];
  });
  var minPosition = positionList[0][axis];
  var maxPosition = positionList[positionList.length - 1][axis];
  var newPosMiddle = (minPosition + maxPosition) / 2;
  var middleDiff = newPosMiddle - avgAxis;

  for (var nodeId in newDeltas) {
    newDeltas[nodeId][axis] = newDeltas[nodeId][axis] - middleDiff - avgSize / 2;
  }
  // if all deltas are the same, don't do anything (we've already aligned everything)
  // and for some reason it keeps returning 1 when there should be no change ¯\_(ツ)_/¯
  if (deltas.every(function (v) {
    return v === deltas[0];
  })) {
    return;
  }
  return newDeltas;
};

// given the pos and size of a node, return the safe position it can go without overlaps
this.getSafePosition = function (_ref12) {
  var node = _ref12.node,
      axis = _ref12.axis,
      sizeField = _ref12.sizeField,
      positionList = _ref12.positionList,
      spacer = _ref12.spacer;

  var safePosition = node[axis];

  var lastPosition = positionList[positionList.length - 1][axis] + positionList[positionList.length - 1][sizeField];
  for (var _iterator10 = positionList, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
    var _ref13;

    if (_isArray10) {
      if (_i10 >= _iterator10.length) break;
      _ref13 = _iterator10[_i10++];
    } else {
      _i10 = _iterator10.next();
      if (_i10.done) break;
      _ref13 = _i10.value;
    }

    var obstacleNode = _ref13;

    // top of node is between top and bottom of another card
    if (_this.overlaps({
      node1: node,
      node2: obstacleNode,
      axis: axis,
      sizeField: sizeField,
      spacer: spacer
    })) {
      safePosition = lastPosition + spacer;
    }
  }

  return safePosition;
};

// return true if the 2 nodes overlap over the given axis
this.overlaps = function (_ref14) {
  var node1 = _ref14.node1,
      node2 = _ref14.node2,
      axis = _ref14.axis,
      sizeField = _ref14.sizeField,
      spacer = _ref14.spacer;

  var obstacleStart = node2[axis];
  var obstacleEnd = node2[axis] + node2[sizeField];
  var nodeStart = node1[axis];
  var nodeEnd = node1[axis] + node1[sizeField];
  // console.log('overlap:',nodeStart,nodeEnd,'vs',obstacleStart,obstacleEnd);
  // top of node is between top and bottom of another card
  if (nodeStart >= obstacleStart - spacer && nodeStart <= obstacleEnd + spacer) {
    return true;
  }

  // bottom of node is between top and bottom of another card
  if (nodeEnd >= obstacleStart - spacer && nodeEnd <= obstacleEnd + spacer) {
    return true;
  }

  // top of node and bottom of node envelope another card
  if (nodeStart <= obstacleStart && nodeEnd >= obstacleEnd) {
    return true;
  }
  return false;
};

this.centerOverlaps = function (_ref15) {
  var node1 = _ref15.node1,
      node2 = _ref15.node2,
      axis = _ref15.axis,
      sizeField = _ref15.sizeField,
      spacer = _ref15.spacer;

  var obstacleStart = node2[axis];
  var obstacleEnd = node2[axis] + node2[sizeField];
  var nodeMiddle = node1[axis] + node1[sizeField] / 2;
  // console.log('overlap:',nodeStart,nodeEnd,'vs',obstacleStart,obstacleEnd);
  // top of node is between top and bottom of another card
  if (nodeMiddle >= obstacleStart - spacer && nodeMiddle <= obstacleEnd + spacer) {
    return true;
  }

  return false;
};

/*
 identify rows and columns of cards that the user laid out by hand and align the cards
 vertically and horizontally with even spacing
 */
this.snapGrid = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes) {
    return;
  }
  _this.capturePreviousPositions();

  // get rows and columns of selected nodes

  var _getRowsAndColumns = _this.getRowsAndColumns(nodes),
      grid = _getRowsAndColumns.grid,
      unassigned = _getRowsAndColumns.unassigned,
      rows = _getRowsAndColumns.rows,
      cols = _getRowsAndColumns.cols;

  // compute spacing and positiong

  var maxHeight = Math.round(Math.max.apply(null, nodes.map(function (n) {
    return n.height;
  })));
  var maxWidth = Math.round(Math.max.apply(null, nodes.map(function (n) {
    return n.width;
  })));
  var minX = Math.round(Math.min.apply(null, nodes.map(function (n) {
    return n.x;
  })));
  var minY = Math.round(Math.min.apply(null, nodes.map(function (n) {
    return n.y;
  })));

  var maxHeightPerRow = rows.map(function (r) {
    return Math.round(Math.max.apply(null, r.filter(function (n) {
      return Boolean(n);
    }).map(function (n) {
      return n.height;
    })));
  });
  var maxWidthPerCol = cols.map(function (c) {
    return Math.round(Math.max.apply(null, c.filter(function (n) {
      return Boolean(n);
    }).map(function (n) {
      return n.width;
    })));
  });

  var avgDistX = _this._getAvgHorizontalDistance(cols, rows);
  // get average vertical space
  var avgDistY = _this._getAvgVerticalDistance(cols, rows);

  var startX = minX;
  var startY = minY;
  var nextX = startX;
  var nextY = startY;
  var newPositions = {};
  var rowNum = 0;
  var colNum = void 0;
  for (var _iterator11 = grid, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
    var _ref16;

    if (_isArray11) {
      if (_i11 >= _iterator11.length) break;
      _ref16 = _iterator11[_i11++];
    } else {
      _i11 = _iterator11.next();
      if (_i11.done) break;
      _ref16 = _i11.value;
    }

    var row = _ref16;

    // base the spacing on the largest element in the current row/column
    maxHeight = maxHeightPerRow[rowNum];
    colNum = 0;
    for (var _iterator13 = row, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
      var _ref18;

      if (_isArray13) {
        if (_i13 >= _iterator13.length) break;
        _ref18 = _iterator13[_i13++];
      } else {
        _i13 = _iterator13.next();
        if (_i13.done) break;
        _ref18 = _i13.value;
      }

      var node = _ref18;

      maxWidth = maxWidthPerCol[colNum];
      if (node) {
        newPositions[node.id] = {
          x: nextX,
          y: nextY
        };
      }
      // if there's only 1 row, evenly space cards, otherwise use maxWidth
      nextX = nextX + avgDistX + (rows.length == 1 ? node.width : maxWidth);
      colNum++;
    }
    if (row.length) {
      nextY = nextY + avgDistY + (cols.length == 1 ? row[0].height : maxHeight);
    }
    nextX = startX;
    rowNum++;
  }

  for (var _iterator12 = nodes, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
    var _ref17;

    if (_isArray12) {
      if (_i12 >= _iterator12.length) break;
      _ref17 = _iterator12[_i12++];
    } else {
      _i12 = _iterator12.next();
      if (_i12.done) break;
      _ref17 = _i12.value;
    }

    var _node3 = _ref17;

    if (!newPositions[_node3.id]) {
      continue;
    }
    _node3.applyMove({
      dx: newPositions[_node3.id].x - _node3.x || 0,
      dy: newPositions[_node3.id].y - _node3.y || 0,
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }

  _this.updateElements();
  _this.saveAlignment();
};

/*
 given a list of nodes that have been positioned by hand,
  determine the rows and columns present
*/
this.getRowsAndColumns = function (nodes) {
  // identify rows and columns of nodes
  var cols = _this._searchForGridCols(nodes);
  var rows = _this._searchForGridRows(nodes);
  // use the rows and columns to get grid coordinates of each node
  var grid = rows.map(function (n) {
    return [];
  });
  grid.push([]); // extra buffer row

  var unassigned = [];
  var conflictNodes = [];

  var _loop = function _loop() {
    if (_isArray14) {
      if (_i14 >= _iterator14.length) return 'break';
      _ref19 = _iterator14[_i14++];
    } else {
      _i14 = _iterator14.next();
      if (_i14.done) return 'break';
      _ref19 = _i14.value;
    }

    var node = _ref19;

    var rowNum = rows.findIndex(function (r) {
      return r.find(function (n) {
        return n.id == node.id;
      });
    });
    var colNum = cols.findIndex(function (c) {
      return c.find(function (n) {
        return n.id == node.id;
      });
    });

    var rowNumFromCol = cols.find(function (c) {
      return c.find(function (n) {
        return n.id == node.id;
      });
    }).findIndex(function (n) {
      return n.id == node.id;
    });
    var colNumFromRow = rows.find(function (r) {
      return r.find(function (n) {
        return n.id == node.id;
      });
    }).findIndex(function (n) {
      return n.id == node.id;
    });

    if (!grid[rowNum][colNum]) {
      grid[rowNum][colNum] = node;
    } else {
      // if there's a conflict, find an appropriate empty slot to put this node
      conflictNodes.push({ node: node, rowNum: rowNum, colNum: colNum });
    }
  };

  for (var _iterator14 = nodes, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
    var _ref19;

    var _ret = _loop();

    if (_ret === 'break') break;
  }
  // place conflicting nodes in any spaces left
  for (var _iterator15 = conflictNodes, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
    var _ref21;

    if (_isArray15) {
      if (_i15 >= _iterator15.length) break;
      _ref21 = _iterator15[_i15++];
    } else {
      _i15 = _iterator15.next();
      if (_i15.done) break;
      _ref21 = _i15.value;
    }

    var _ref22 = _ref21;
    var _node4 = _ref22.node,
        _rowNum = _ref22.rowNum,
        _colNum = _ref22.colNum;

    var residentNode = grid[_rowNum][_colNum];
    if (residentNode.x <= _node4.x) {
      if (!grid[_rowNum][_colNum + 1]) {
        grid[_rowNum][_colNum + 1] = _node4;
        continue;
      }
      if (residentNode.y <= _node4.y && !grid[_rowNum + 1][_colNum + 1]) {
        grid[_rowNum + 1][_colNum + 1] = _node4;
        continue;
      }
      if (residentNode.y >= _node4.y && _rowNum > 0 && !grid[_rowNum - 1][_colNum + 1]) {
        grid[_rowNum - 1][_colNum + 1] = _node4;
        continue;
      }
    }

    if (residentNode.x >= _node4.x) {
      if (_colNum > 0 && !grid[_rowNum][_colNum - 1]) {
        grid[_rowNum][_colNum - 1] = _node4;
        continue;
      }
      if (residentNode.y <= _node4.y && _colNum > 0 && !grid[_rowNum + 1][_colNum - 1]) {
        grid[_rowNum + 1][_colNum - 1] = _node4;
        continue;
      }
      if (residentNode.y >= _node4.y && _rowNum > 0 && _colNum > 0 && !grid[_rowNum - 1][_colNum - 1]) {
        grid[_rowNum - 1][_colNum - 1] = _node4;
        continue;
      }
    }

    if (residentNode.y <= _node4.y) {
      if (!grid[_rowNum + 1][_colNum]) {
        grid[_rowNum + 1][_colNum] = _node4;
        continue;
      }
      if (residentNode.x <= _node4.x && !grid[_rowNum + 1][_colNum + 1]) {
        grid[_rowNum + 1][_colNum + 1] = _node4;
        continue;
      }
      if (residentNode.x >= _node4.x && _colNum > 0 && !grid[_rowNum + 1][_colNum - 1]) {
        grid[_rowNum + 1][_colNum - 1] = _node4;
        continue;
      }
    }
    if (residentNode.y >= _node4.y) {

      if (_rowNum > 0 && !grid[_rowNum - 1][_colNum]) {
        grid[_rowNum - 1][_colNum] = _node4;
        continue;
      }
      if (residentNode.x <= _node4.x && _rowNum > 0 && !grid[_rowNum - 1][_colNum + 1]) {
        grid[_rowNum - 1][_colNum + 1] = _node4;
        continue;
      }
      if (residentNode.x >= _node4.x && _rowNum > 0 && _colNum > 0 && !grid[_rowNum - 1][_colNum - 1]) {
        grid[_rowNum - 1][_colNum - 1] = _node4;
        continue;
      }
    }

    // last ditch effort to find any empty spot surrounding the conflicting node slot
    var _arr = [-1, 0, 1];

    rowLoop: for (var _i16 = 0; _i16 < _arr.length; _i16++) {
      var offsetRow = _arr[_i16];var _arr2 = [-1, 0, 1];

      for (var _i17 = 0; _i17 < _arr2.length; _i17++) {
        var offsetCol = _arr2[_i17];
        if (!grid[_rowNum - offsetRow][_colNum - offsetCol]) {
          if (!grid[_rowNum - offsetRow]) {
            grid[_rowNum - offsetRow] = [];
          }
          grid[_rowNum - offsetRow][_colNum - offsetCol] = _node4;
          break rowLoop;
        };
      }
    }
  }
  return { grid: grid, unassigned: unassigned, rows: rows, cols: cols };
};

// TODO: try and simplify these using averageMap
this._getAvgHorizontalDistance = function (cols, rows) {
  // get average horizontal space between nodes
  var distsX = [];

  for (var i = 1; i < cols.length; i++) {
    var col1 = cols[i - 1];
    var col2 = cols[i];

    for (var _iterator16 = col1, _isArray16 = Array.isArray(_iterator16), _i18 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
      var _ref23;

      if (_isArray16) {
        if (_i18 >= _iterator16.length) break;
        _ref23 = _iterator16[_i18++];
      } else {
        _i18 = _iterator16.next();
        if (_i18.done) break;
        _ref23 = _i18.value;
      }

      var n1 = _ref23;

      for (var _iterator17 = col2, _isArray17 = Array.isArray(_iterator17), _i19 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
        var _ref24;

        if (_isArray17) {
          if (_i19 >= _iterator17.length) break;
          _ref24 = _iterator17[_i19++];
        } else {
          _i19 = _iterator17.next();
          if (_i19.done) break;
          _ref24 = _i19.value;
        }

        var n2 = _ref24;

        if (!n1 || !n2) {
          continue;
        }
        if (n1.y >= n2.y) {
          // ignore if element is below next row's element
          continue;
        }

        // use spacing between nodes if they're within a decent distance from each other...
        var distX = n2.x - (n1.x + n1.width);
        if (distX >= 10) {
          distsX.push(distX);
        }
      }
    }
  }
  var spacer = distsX.length ? Math.min.apply(null, distsX) : 10;
  var sumDistX = distsX.reduce(function (a, b) {
    return a + b;
  }, 0);
  var spacer2 = Math.abs(Math.round(sumDistX / distsX.length));

  // don't use the average dist if its much larger than the min distance
  if (spacer2 > spacer * 4) {
    return spacer;
  }
  return spacer2;
};

this._getAvgVerticalDistance = function (cols, rows) {
  // get average space by comparing nodes between rows
  var distsY = [];
  for (var i = 1; i < rows.length; i++) {
    var row1 = rows[i - 1];
    var row2 = rows[i];

    for (var _iterator18 = row1, _isArray18 = Array.isArray(_iterator18), _i20 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();;) {
      var _ref25;

      if (_isArray18) {
        if (_i20 >= _iterator18.length) break;
        _ref25 = _iterator18[_i20++];
      } else {
        _i20 = _iterator18.next();
        if (_i20.done) break;
        _ref25 = _i20.value;
      }

      var n1 = _ref25;

      for (var _iterator19 = row2, _isArray19 = Array.isArray(_iterator19), _i21 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();;) {
        var _ref26;

        if (_isArray19) {
          if (_i21 >= _iterator19.length) break;
          _ref26 = _iterator19[_i21++];
        } else {
          _i21 = _iterator19.next();
          if (_i21.done) break;
          _ref26 = _i21.value;
        }

        var n2 = _ref26;

        if (!n1 || !n2) {
          continue;
        }
        if (n1.y >= n2.y) {
          // ignore if element is below next row's element
          continue;
        }

        // use spacing between nodes if they're within a decent distance from each other...
        var distY = n2.y - (n1.y + n1.height);
        if (distY > 0) {
          distsY.push(distY);
        }
      }
    }
  }
  var spacer = 10;
  if (distsY.length) {
    var sumDistY = distsY.reduce(function (a, b) {
      return a + b;
    }, 0);
    spacer = Math.abs(Math.round(sumDistY / distsY.length));
  }

  // calculate distances based on column data
  var distsY2 = [];
  for (var _iterator20 = cols, _isArray20 = Array.isArray(_iterator20), _i22 = 0, _iterator20 = _isArray20 ? _iterator20 : _iterator20[Symbol.iterator]();;) {
    var _ref27;

    if (_isArray20) {
      if (_i22 >= _iterator20.length) break;
      _ref27 = _iterator20[_i22++];
    } else {
      _i22 = _iterator20.next();
      if (_i22.done) break;
      _ref27 = _i22.value;
    }

    var col = _ref27;

    for (var _i23 = 1; _i23 < col.length; _i23++) {
      if (!col[_i23] || !col[_i23 - 1]) {
        continue;
      }
      var _distY = col[_i23].y - (col[_i23 - 1].y + col[_i23 - 1].height);
      if (_distY > 0) {
        distsY2.push(_distY);
      }
    }
  }
  var sumDistY2 = distsY2.reduce(function (a, b) {
    return a + b;
  }, 0);
  var spacer2 = Math.abs(Math.round(sumDistY2 / distsY2.length));
  return Math.max(Math.min(spacer, spacer2), 10);
};

this.sortByTopLeftProximity = function (nodes) {
  var minX = Math.round(Math.min.apply(null, nodes.map(function (n) {
    return n.x;
  })));
  var minY = Math.round(Math.min.apply(null, nodes.map(function (n) {
    return n.y;
  })));
  var topLeft = { x: minX, y: minY };
  var distances = {};
  for (var _iterator21 = nodes, _isArray21 = Array.isArray(_iterator21), _i24 = 0, _iterator21 = _isArray21 ? _iterator21 : _iterator21[Symbol.iterator]();;) {
    var _ref28;

    if (_isArray21) {
      if (_i24 >= _iterator21.length) break;
      _ref28 = _iterator21[_i24++];
    } else {
      _i24 = _iterator21.next();
      if (_i24.done) break;
      _ref28 = _i24.value;
    }

    var n = _ref28;

    distances[n.id] = (0, _geom.pointDistance)(topLeft, n);
  }
  return nodes.concat().sort(function (a, b) {
    return distances[a.id] - distances[b.id];
  });
};

this._searchForGridCols = function (nodes) {
  var assigned = {};
  var cols = [];
  var _nodes = _this.sortByTopLeftProximity(nodes);
  for (var _iterator22 = _nodes, _isArray22 = Array.isArray(_iterator22), _i25 = 0, _iterator22 = _isArray22 ? _iterator22 : _iterator22[Symbol.iterator]();;) {
    var _ref29;

    if (_isArray22) {
      if (_i25 >= _iterator22.length) break;
      _ref29 = _iterator22[_i25++];
    } else {
      _i25 = _iterator22.next();
      if (_i25.done) break;
      _ref29 = _i25.value;
    }

    var _node5 = _ref29;

    if (assigned[_node5.id]) {
      continue;
    }
    var col = _this._getCol({ node: _node5, nodes: nodes, assigned: assigned });
    // ignore column if we already indexed any of its nodes
    if (col.every(function (n) {
      return assigned[n.id];
    })) {
      continue;
    }
    if (col.some(function (n) {
      return assigned[n.id];
    })) {
      col = col.filter(function (n) {
        return !assigned[n.id];
      });
    }
    for (var _iterator23 = col, _isArray23 = Array.isArray(_iterator23), _i26 = 0, _iterator23 = _isArray23 ? _iterator23 : _iterator23[Symbol.iterator]();;) {
      var _ref30;

      if (_isArray23) {
        if (_i26 >= _iterator23.length) break;
        _ref30 = _iterator23[_i26++];
      } else {
        _i26 = _iterator23.next();
        if (_i26.done) break;
        _ref30 = _i26.value;
      }

      var n = _ref30;

      assigned[n.id] = true;
    }
    cols.push(col);
  }

  cols.sort(function (a, b) {
    return a[0].x - b[0].x;
  });
  return cols;
};

this._searchForGridRows = function (nodes) {
  var assigned = {};
  var rows = [];
  var _nodes = _this.sortByTopLeftProximity(nodes);
  for (var _iterator24 = _nodes, _isArray24 = Array.isArray(_iterator24), _i27 = 0, _iterator24 = _isArray24 ? _iterator24 : _iterator24[Symbol.iterator]();;) {
    var _ref31;

    if (_isArray24) {
      if (_i27 >= _iterator24.length) break;
      _ref31 = _iterator24[_i27++];
    } else {
      _i27 = _iterator24.next();
      if (_i27.done) break;
      _ref31 = _i27.value;
    }

    var _node6 = _ref31;

    if (assigned[_node6.id]) {
      continue;
    }
    var row = _this._getRow({ node: _node6, nodes: nodes, assigned: assigned });
    // ignore column if we already indexed any of its nodes
    if (row.every(function (n) {
      return assigned[n.id];
    })) {
      continue;
    }
    if (row.some(function (n) {
      return assigned[n.id];
    })) {
      row = row.filter(function (n) {
        return !assigned[n.id];
      });
    }
    for (var _iterator25 = row, _isArray25 = Array.isArray(_iterator25), _i28 = 0, _iterator25 = _isArray25 ? _iterator25 : _iterator25[Symbol.iterator]();;) {
      var _ref32;

      if (_isArray25) {
        if (_i28 >= _iterator25.length) break;
        _ref32 = _iterator25[_i28++];
      } else {
        _i28 = _iterator25.next();
        if (_i28.done) break;
        _ref32 = _i28.value;
      }

      var n = _ref32;

      assigned[n.id] = true;
    }
    rows.push(row);
  }

  rows.sort(function (a, b) {
    return a[0].y - b[0].y;
  });
  return rows;
};

// get all elements in a row with the given node
this._getRow = function (_ref33) {
  var node = _ref33.node,
      nodes = _ref33.nodes,
      assigned = _ref33.assigned;

  var _nodes = _this.sortByTopLeftProximity(nodes);
  var lastNode = node;
  var row = [lastNode];
  var localAssigned = {};
  localAssigned[lastNode.id] = true;
  for (var _iterator26 = _nodes, _isArray26 = Array.isArray(_iterator26), _i29 = 0, _iterator26 = _isArray26 ? _iterator26 : _iterator26[Symbol.iterator]();;) {
    var _ref34;

    if (_isArray26) {
      if (_i29 >= _iterator26.length) break;
      _ref34 = _iterator26[_i29++];
    } else {
      _i29 = _iterator26.next();
      if (_i29.done) break;
      _ref34 = _i29.value;
    }

    var n = _ref34;

    if (n.id === lastNode.id) {
      continue;
    }
    if (assigned[n.id] || localAssigned[n.id]) {
      continue;
    }

    if (_this.overlaps({
      node1: lastNode,
      node2: n,
      axis: 'y',
      sizeField: 'height',
      spacer: 0
    }) && !_this._nodeIsInColumns(n, row, 0)) {
      row.push(n);
      localAssigned[n.id] = true;
      lastNode = n;
    }
  }
  row.sort(function (a, b) {
    return a.x - b.x;
  });
  return row;
};

// get all elements in a column with the given node
this._getCol = function (_ref35) {
  var node = _ref35.node,
      nodes = _ref35.nodes,
      assigned = _ref35.assigned;

  var _nodes = _this.sortByTopLeftProximity(nodes);
  var lastNode = node;
  var col = [lastNode];
  var localAssigned = {};
  localAssigned[lastNode.id] = true;
  for (var _iterator27 = _nodes, _isArray27 = Array.isArray(_iterator27), _i30 = 0, _iterator27 = _isArray27 ? _iterator27 : _iterator27[Symbol.iterator]();;) {
    var _ref36;

    if (_isArray27) {
      if (_i30 >= _iterator27.length) break;
      _ref36 = _iterator27[_i30++];
    } else {
      _i30 = _iterator27.next();
      if (_i30.done) break;
      _ref36 = _i30.value;
    }

    var n = _ref36;

    if (n.id === lastNode.id) {
      continue;
    }
    if (assigned[n.id] || localAssigned[n.id]) {
      continue;
    }
    if (_this.overlaps({
      node1: lastNode,
      node2: n,
      axis: 'x',
      sizeField: 'width',
      spacer: 0
    })) {
      col.push(n);
      localAssigned[n.id] = true;
      lastNode = n;
    }
  }
  col.sort(function (a, b) {
    return a.y - b.y;
  });
  return col;
};

/*
  return true if node is in a column with any of the list of nodes
*/
this._nodeIsInColumns = function (node, nodes, spacer) {
  return nodes.some(function (n) {
    return _this.overlaps({
      node1: node,
      node2: n,
      axis: 'x',
      sizeField: 'width',
      spacer: spacer
    });
  });
};

this.alignCircle = function () {

  var nodes = _this.getAlignableNodes();
  if (!nodes) return;
  _this.capturePreviousPositions();

  function testIntersection(r1, r2) {
    if (r1.left > r2.right || r2.left > r1.right) return false;
    if (r1.top > r2.bottom || r1.bottom < r2.top) return false;
    return true;
  }

  function testAllIntersections(rs) {
    var hit = false;
    for (var _iterator28 = rs, _isArray28 = Array.isArray(_iterator28), _i31 = 0, _iterator28 = _isArray28 ? _iterator28 : _iterator28[Symbol.iterator]();;) {
      var _ref37;

      if (_isArray28) {
        if (_i31 >= _iterator28.length) break;
        _ref37 = _iterator28[_i31++];
      } else {
        _i31 = _iterator28.next();
        if (_i31.done) break;
        _ref37 = _i31.value;
      }

      var _r = _ref37;

      if (testIntersections(_r, rs)) return true;
    }
  }

  function testIntersections(r0, rs) {
    var hit = false;
    for (var _iterator29 = rs, _isArray29 = Array.isArray(_iterator29), _i32 = 0, _iterator29 = _isArray29 ? _iterator29 : _iterator29[Symbol.iterator]();;) {
      var _ref38;

      if (_isArray29) {
        if (_i32 >= _iterator29.length) break;
        _ref38 = _iterator29[_i32++];
      } else {
        _i32 = _iterator29.next();
        if (_i32.done) break;
        _ref38 = _i32.value;
      }

      var _r2 = _ref38;

      if (r0 == _r2 || _r2.id && _r2.id == r0.id) continue;
      if (testIntersection(r0, _r2)) hit = true;
    }
    return hit;
  }

  var repel = function repel(points, r) {
    // find our radius and center point
    var c = center(points);

    // sort points by their angle from the center
    var angle = function angle(p) {
      return Math.atan2(p.y - c.y, p.x - c.x);
    };
    points.sort(function (a, b) {
      return angle(a) - angle(b);
    });

    // padding between each point is its proportional share of the arc
    var pad = Math.PI * 2 / points.length;

    var np = new Map();
    var last = null;

    for (var _iterator30 = points, _isArray30 = Array.isArray(_iterator30), _i33 = 0, _iterator30 = _isArray30 ? _iterator30 : _iterator30[Symbol.iterator]();;) {
      var _ref39;

      if (_isArray30) {
        if (_i33 >= _iterator30.length) break;
        _ref39 = _iterator30[_i33++];
      } else {
        _i33 = _iterator30.next();
        if (_i33.done) break;
        _ref39 = _i33.value;
      }

      var p = _ref39;

      // project each point at its angle a radius' length from the center
      var a = last == null ? angle(p) : last + pad;
      var x = Math.cos(a) * r + c.x;
      var y = Math.sin(a) * r + c.y;
      last = a;
      np.set(p, [x, y]);
    }
    return [np, c, r];
  };

  var radius = function radius(points) {
    return (0, _smallestCircle2.default)(points).r;
  };

  var center = function center(points) {
    // center point is the average of xs and ys
    var x = average(points.map(function (p) {
      return p.x;
    }));
    var y = average(points.map(function (p) {
      return p.y;
    }));
    return { x: x, y: y };
  };

  var average = function average(arr) {
    return arr.reduce(function (p, c) {
      return p + c;
    }, 0) / arr.length;
  };

  var distances = function distances(points) {
    var ds = [];
    for (var _iterator31 = points, _isArray31 = Array.isArray(_iterator31), _i34 = 0, _iterator31 = _isArray31 ? _iterator31 : _iterator31[Symbol.iterator]();;) {
      var _ref40;

      if (_isArray31) {
        if (_i34 >= _iterator31.length) break;
        _ref40 = _iterator31[_i34++];
      } else {
        _i34 = _iterator31.next();
        if (_i34.done) break;
        _ref40 = _i34.value;
      }

      var p0 = _ref40;

      for (var _iterator32 = points, _isArray32 = Array.isArray(_iterator32), _i35 = 0, _iterator32 = _isArray32 ? _iterator32 : _iterator32[Symbol.iterator]();;) {
        var _ref41;

        if (_isArray32) {
          if (_i35 >= _iterator32.length) break;
          _ref41 = _iterator32[_i35++];
        } else {
          _i35 = _iterator32.next();
          if (_i35.done) break;
          _ref41 = _i35.value;
        }

        var p1 = _ref41;

        if (p0 == p1) continue;
        ds.push(Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2)));
      }
    }
    return ds.sort(function (a, b) {
      return a - b;
    });
  };

  var multiplier = 1;
  var intersections = null;
  var np = void 0,
      c = void 0,
      r = void 0;

  while (multiplier < 3 && (intersections === null || intersections == true)) {

    r = multiplier * radius(nodes);

    var _repel = repel(nodes, r);

    np = _repel[0];
    c = _repel[1];
    r = _repel[2];

    var rects = [];
    for (var _iterator33 = np.keys(), _isArray33 = Array.isArray(_iterator33), _i36 = 0, _iterator33 = _isArray33 ? _iterator33 : _iterator33[Symbol.iterator]();;) {
      var _ref42;

      if (_isArray33) {
        if (_i36 >= _iterator33.length) break;
        _ref42 = _iterator33[_i36++];
      } else {
        _i36 = _iterator33.next();
        if (_i36.done) break;
        _ref42 = _i36.value;
      }

      var n = _ref42;

      rects.push({
        top: np.get(n)[1],
        left: np.get(n)[0],
        bottom: np.get(n)[1] + n.height,
        right: np.get(n)[0] + n.width
      });
    }

    // if we have intersections try with a bigger radius
    intersections = testAllIntersections(rects);
    multiplier *= 1.25;
  }

  for (var _iterator34 = nodes, _isArray34 = Array.isArray(_iterator34), _i37 = 0, _iterator34 = _isArray34 ? _iterator34 : _iterator34[Symbol.iterator]();;) {
    var _ref43;

    if (_isArray34) {
      if (_i37 >= _iterator34.length) break;
      _ref43 = _iterator34[_i37++];
    } else {
      _i37 = _iterator34.next();
      if (_i37.done) break;
      _ref43 = _i37.value;
    }

    var _node7 = _ref43;

    var p = np.get(_node7);
    _node7.applyMove({
      dx: p[0] - _node7.x,
      dy: p[1] - _node7.y,
      appliedMoveLookup: {},
      canvas: _this.canvas
    });
  }

  var _loop2 = function _loop2(i) {
    var _nodes$slice = nodes.slice(i - 1, i || undefined),
        n1 = _nodes$slice[0];

    var _nodes$slice2 = nodes.slice(i, i + 1),
        n2 = _nodes$slice2[0];

    var tmp = void 0;

    var links = _store_instance2.default.getLinks().filter(function (l) {
      return l.fromNodeId == n1.id && l.toNodeId == n2.id || l.fromNodeId == n2.id && l.toNodeId == n1.id;
    });

    if (links.length != 1) return 'continue';
    var link = links[0];

    if (link.fromNodeId == n2.id) {
      // swap to and from nodes if they're backwards
      tmp = n1, n1 = n2, n2 = tmp;
    }

    // find existing angles from the center point to nodes
    var a1 = Math.atan2(n1.y - c.y, n1.x - c.x);
    var a2 = Math.atan2(n2.y - c.y, n2.x - c.x);

    // normalize angles so we don't go the long way 'round
    if (a1 > Math.PI / 2 && a2 < -Math.PI / 2) {
      a2 += 2 * Math.PI;
    }
    if (a2 > Math.PI / 2 && a1 < -Math.PI / 2) {
      a1 += 2 * Math.PI;
    }

    // our new point should be half way in between
    var ra = average([a1, a2]);

    // this may be to counteract offsets from link.getOffsetLinkPoints
    var yOffset = -15;

    // new point is projected out at radius length
    var rx = Math.cos(ra) * r + c.x;
    var ry = Math.sin(ra) * r + c.y + yOffset;

    // find angles relative the chord between n1 and n2
    var ch = Math.atan2(n2.y - n1.y, n2.x - n1.x);
    var sa = Math.atan2(n1.y - ry, n1.x - rx) - ch;
    var ea = Math.atan2(n2.y - ry, n2.x - rx) - ch;

    link.setAngles({ angleStartToR: sa, angleEndToR: ea });
  };

  for (var i = 0; i < nodes.length; i++) {
    var _ret2 = _loop2(i);

    if (_ret2 === 'continue') continue;
  }

  _this.updateElements();
  _this.saveAlignment();
};

this.capturePreviousPositions = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes || !nodes.length) {
    return;
  }
  var _targetIds = _nodesUi.nui.computeAllSelectedMovingParts(_store_instance2.default, nodes[0], _this.canvas);
  _this.targetNodeIds = _targetIds.targetNodeIds;
  _this.targetLinkIds = _targetIds.targetLinkIds;
  _this.prevNodePositions = _store_instance2.default.getNodePositions(nodes.map(function (n) {
    return n.id;
  }));
  _this.prevLinkAngles = _store_instance2.default.getLinkAngles(_this.targetLinkIds);
};

this.saveAlignment = function () {
  var nodes = _this.getAlignableNodes();
  if (!nodes || !nodes.length) {
    return;
  }
  self.operation.updateNodePositions({
    prevNodePositions: _this.prevNodePositions,
    prevLinkAngles: _this.prevLinkAngles,
    nodePositions: _store_instance2.default.getNodePositions(_this.targetNodeIds),
    linkAngles: _store_instance2.default.getLinkAngles(_this.targetLinkIds),
    nodes: nodes
  });
};

this.updateElements = function () {
  var _canvas = _this.canvas,
      nodeTags = _canvas.nodeTags,
      multiSelectionIndicatorBox = _canvas.multiSelectionIndicatorBox;

  var nodes = _this.getAlignableNodes();
  if (!nodes || !nodes.length) {
    return;
  }

  var animate = true;
  // if there are links connected to these nodes, don't animate
  // because the transition breaks link placement now...
  if (nodes.find(function (n) {
    return n.descendantsLinks().length > 0;
  })) {
    animate = false;
  }
  if (animate) {
    document.body.classList.add('transitioning-nodes');
  }
  for (var _iterator35 = nodes, _isArray35 = Array.isArray(_iterator35), _i38 = 0, _iterator35 = _isArray35 ? _iterator35 : _iterator35[Symbol.iterator]();;) {
    var _ref44;

    if (_isArray35) {
      if (_i38 >= _iterator35.length) break;
      _ref44 = _iterator35[_i38++];
    } else {
      _i38 = _iterator35.next();
      if (_i38.done) break;
      _ref44 = _i38.value;
    }

    var _node8 = _ref44;

    if (nodeTags[_node8.id]) {
      nodeTags[_node8.id].updateTopLevelNeighborsLite();
      nodeTags[_node8.id].rediscoverLinkPositions();
    }
  }

  (0, _util.refreshFreehandAncestorsOfList)(nodes, _this, _store_instance2.default);

  if (animate) {
    multiSelectionIndicatorBox.hide();

    setTimeout(function () {
      document.body.classList.remove('transitioning-nodes');
      multiSelectionIndicatorBox.update();
    }, 500);
  } else {
    multiSelectionIndicatorBox.update();
  }
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};

this.on('mount', function () {
  $(_this.root).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.on('updated', _eventTracking2.default.listen(this.root));

this.getTrackingLabel = function () {
  return (0, _util.getTrackingLabel)({ menuName: _this.origin });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-alignment-panel')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-alignment-panel.html
// module id = 642
// module chunks = 0